<header-title [model]="headerTitle"></header-title>

<section role="main" class="">
    <section class="card mt-4">
        <header class="card-header">
            <h5 class="text-muted"><i class="fas fa-tasks"></i> Edit Audit</h5>
        </header>
        <div class="card-body" *ngIf="updateAuditFormGroup">
            <form [formGroup]="updateAuditFormGroup">
                <error-message [errors]="errors"></error-message>
                <div class="container">

                    <div class="row mt-5">
                        <div class="col">
                            <div class="row mb-2">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <input type="hidden" name="id" formControlName="id" />
                                        <label class="col-form-label">Title</label>
                                        <input name="title" class="form-control" formControlName="title"
                                        [class.border-danger]="title?.errors?.required && title?.touched"/>
                                    </div>
                                    <div *ngIf="title?.errors?.required && title?.touched">
                                        <label class="control-label text-danger">
                                            A title is required.
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="col-form-label">Audit Template</label>
                                        <input title="Cannot be changed" *ngIf="companyAuditModel" type="text" id="tmp" name="tmp" class="form-control" [readOnly]="true" value="{{companyAuditModel.auditTemplateDescription}}" data-toggle="tooltip" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="">External Audit</label>
                                        <input type="checkbox" id="isExternal" name="isExternal" class="form-control" formControlName="isExternal" appToggle />
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-2 mt-2">
                                <div class="col-md-4 col-lg-3">
                                    <div class="form-group">
                                        <label class="control-label text-info">Start Date</label>
                                        <input id="startDate"
                                               name="startDate"
                                               class="form-control"
                                               formControlName="startDate"
                                               type="text"
                                               placeholder="DD/MM/YYYY"
                                               bsDatepicker
                                               [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }"
                                               [class.border-danger]="startDate?.errors?.required && startDate?.touched">
                                    </div>
                                    <div *ngIf="startDate?.errors?.required && startDate?.touched">
                                        <label class="control-label text-danger">
                                            The Start Date is required.
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-3">
                                    <div class="form-group">
                                        <label class="control-label text-info">Deadline Date</label>
                                        <input id="deadlineDate"
                                               name="deadlineDate"
                                               class="form-control"
                                               formControlName="deadlineDate"
                                               type="text"
                                               placeholder="DD/MM/YYYY"
                                               bsDatepicker
                                               [minDate]="updateAuditFormGroup.value.startDate"
                                               [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }"
                                               [class.border-danger]="deadlineDate?.value && (deadlineDate?.value < startDate.value)">
                                    </div>
                                    <div *ngIf="deadlineDate?.value && (deadlineDate?.value < startDate.value)">
                                        <label class="control-label text-danger">
                                            The Deadline must be after the start date.
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row my-5">
                        <div class="col d-flex justify-content-between">
                            <button class="btn btn-outline-primary mr-2" type="button" (click)="onBack()">Back</button>
                            <button class="btn btn-success" type="button" [disabled]="!updateAuditFormGroup.valid" (click)="updateAudit();">Update Audit</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>

</section>


<app-alert-message (successClicked)="successClicked($event)"
                   (onHide)="onHide($event)"
                   [title]="'Success'"
                   [message]="'The Audit Updated'">
</app-alert-message>
